import { ScrollView } from '@fhs-legacy/universal-components';

export const Wrapper = ScrollView;
